<template>
    <CurrencyRatesList/>
</template>

<script>
import CurrencyRatesList from '../../components/currency-rates/CurrencyRatesList';

export default {
  components: {
    CurrencyRatesList,
  },
};
</script>
